import React from 'react';
import ProductCardList from 'components/NewHome/ProductCardList';
import MobileProductModuleList from 'components/NewHome/Mobile/MobileProductModuleList';
import { adminProductList } from 'helper/Home/productCardList';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function Admin() {
  if (useIsMobile()) {
    return <MobileProductModuleList title="ADMINISTRAÇÃO" products={adminProductList} />;
  }

  return (
    <div className="dark-outlet-background">
      <h1 className="mb-5">ADMINISTRAÇÃO</h1>
      <ProductCardList products={adminProductList} />
    </div>
  );
}
